import { FC, useEffect } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { RESPONSE_CODE } from "../../shared/models/Types";
import { errorNotify, successNotify } from "../../shared/utils/notifications";
import { Col, Row } from "reactstrap";
import { useDeviceBuySellDeleteMutation } from "./BuySell.actions";
import { DeviceBuySellDeviceDeleteModalProps } from "./BuySell.constants";

const DeviceBuySellDeviceDeleteModal: FC<
  DeviceBuySellDeviceDeleteModalProps
> = ({ deviceData, isModalOpen, toggle, buySellDevicePartListMutation }) => {
  const { data, mutate, isLoading } = useDeviceBuySellDeleteMutation();

  const onDeleteClick = () => {
    deviceData && mutate(deviceData);
  };

  useEffect(() => {
    if (data === RESPONSE_CODE.DELETED) {
      successNotify("Cihaz alış/satış başarılı bir şekilde silindi.");
      toggle();

      buySellDevicePartListMutation(0);
    }

    if (data === RESPONSE_CODE.ERROR) {
      errorNotify("Cihaz alış/satış zaten silinmiş yada bir hata var.");
      toggle();
    }
  }, [data]);

  return (
    <ModalComponent
      header={"Cihaz alış/satış Silme"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col lg={12}>
          <div className="text-center">
            <i
              className="mdi mdi-alert-circle-outline"
              style={{ fontSize: "5em", color: "orange" }}
            />
            <h2>Emin misin?</h2>
            <h4>{"Cihaz alış/satış silinecektir onaylıyormusunuz!"}</h4>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="text-center mt-3">
            <button
              disabled={isLoading}
              type="button"
              className="btn btn-success btn-lg ms-2"
              onClick={() => onDeleteClick()}
            >
              Evet Sil!
            </button>
            <button
              type="button"
              className="btn btn-danger btn-lg ms-2"
              onClick={toggle}
            >
              Çıkış
            </button>
          </div>
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default DeviceBuySellDeviceDeleteModal;
